<div *ngIf="reportType == 'OfficeRepUnpaidbriefly'">

    <!-- ===== BUTTONS ===== -->
    <div style="margin-left: 80%; margin-top: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Office_Rep_UnpaidOutstanding_Brief_Report')" 
            mat-raised-button color="primary">
            Export
        </button>

        <button class="btn btn-primary noPrint" 
            style="margin-top: 2%; margin-left: 2%;"
            (click)="printPage42()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" 
            mat-button mat-dialog-close>
            Close
        </button>
    </div>

    <!-- ===== REPORT TABLE ===== -->
   <div class="container" id="print-section">

  <table class="table table-bordered">

    <!-- ================= HEADER ================= -->
    <thead>

      <!-- ===== TITLE ROW ===== -->
      <tr>
        <th colspan="1"
            style="border:1px solid black; font-size:18px; font-weight:bold;
                   text-align:center; padding:8px;">
          हिंदुस्तान प्रकाशन संस्था
        </th>

        <th colspan="2"
            style="border:1px solid black; font-size:20px; font-weight:bold;
                   text-align:center; padding:8px;">
          Book Outstanding Report
        </th>

        <th colspan="2"
            style="border:1px solid black; font-size:16px; font-weight:bold;
                   text-align:right; padding:8px; white-space:nowrap;">
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <!-- ===== SUB TITLE ROW ===== -->
      <tr>
        <th colspan="1"
            style="border:1px solid black; font-size:18px;
                   text-align:center; padding:8px; font-weight:bold;">
          विवेक पुस्तक प्रकाशन
        </th>

        <th colspan="2"
            style="border:1px solid black; font-size:18px;
                   text-align:center; padding:8px; font-weight:bold;">
          Office Rep Unpaid very Briefly
        </th>

        <th colspan="2"
            style="border:1px solid black; font-size:16px;
                   text-align:right; padding:8px; font-weight:bold;
                   white-space:nowrap;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }}<br>
          To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <!-- ===== COLUMN HEADERS ===== -->
      <tr>
        <th style="border:1px solid black; padding:6px; font-size:16px;width:40%;">
          Office Rep Name
        </th>

        <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Invoice Amount
        </th>

        <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Paid Amount
        </th>

        <!-- <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Credit Amount
        </th> -->

        <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Unpaid Amount
        </th>
      </tr>

    </thead>

    <!-- ================= BODY ================= -->
    <tbody>

      <tr *ngFor="let data of UnpaidOutstandingB">
        <td style="border:1px solid black; padding:6px; font-size:16px;">
          {{ data.off_rep_name }}
        </td>

        <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.inv_Total }}
        </td>

        <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.paid_Total }}
        </td>

        <!-- <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.crdt_Total }}
        </td> -->

        <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.bal_Total }}
        </td>
      </tr>

      <!-- ===== GRAND TOTAL ===== -->
      <tr style="background-color:#c8753f; font-weight:bold; font-size:16px;">
        <td style="border:1px solid black; padding:6px;">
          Grand Total :
        </td>

        <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalInvAmount }}
        </td>

        <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalPaidAmount }}
        </td>

        <!-- <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalCrdtAmount }}
        </td> -->

        <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalUnpaidAmount }}
        </td>
      </tr>

    </tbody>

  </table>

</div>


</div>